module.exports = __webpack_public_path__ + "img/banner-bg-mobile2.d75107ee.png";